import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import TopBar from "../Container/TopBar";
import CopyRates from "../CopyRates";
import ExportSql from "../ExportSql";
import NotFound from "../NotFound";
import LoadingCall from "../../js/LoadingCall";
import { useLogin } from "../../context/LoginContext";

export default function RouteContent() {
  const { loginData, sessionStatus, storeLoginData } = useLogin();
  const isNotLoggedIn =
    loginData.length === 0 ||
    loginData?.conv_user_log_id === undefined ||
    loginData?.conv_user_log_id === "";
  const isEmergencyMaintenance =
    process.env.REACT_APP_EMERGENCY_MAINTENANCE === "true" ||
    process.env.REACT_APP_SYSTEM_CLOSED === "true";

  if (isEmergencyMaintenance) {
    return (
      <div
        id="container"
        className="container"
        style={{
          width: "100%",
          minHeight: "100vh",
          margin: 0,
          backgroundColor: "#f4f6f5",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: "80px 24px 24px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "760px",
            backgroundColor: "#ffffff",
            border: "1px solid #d9dfdc",
            borderRadius: "10px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
            padding: "40px 32px",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            color: "#4d5752",
            lineHeight: "1.7",
          }}
        >
          <h1
            style={{
              margin: "0 0 16px",
              color: "#2f6f4f",
              fontSize: "2rem",
              fontWeight: 700,
            }}
          >
            Server Under Emergency Maintenance
          </h1>
          <p style={{ margin: "0 0 8px", fontSize: "1.05rem" }}>
            We are currently performing emergency maintenance to resolve a
            critical issue.
          </p>
          <p style={{ margin: "0 0 8px", fontSize: "1.05rem" }}>
            Our team is working hard to restore normal service as quickly as
            possible.
          </p>
          <p style={{ margin: "0 0 8px", color: "#6a7570" }}>
            Please check back shortly.
          </p>
          <p style={{ margin: 0, color: "#6a7570" }}>
            Thank you for your patience and understanding.
          </p>
          <p
            style={{
              margin: "14px 0 0",
              color: "#6a7570",
              fontSize: "0.98rem",
            }}
          >
            For urgent issues, please contact Nattanan Seeruang or submit a
            support ticket.
          </p>
        </div>
      </div>
    );
  } else if (sessionStatus === "checking") {
    return <>{LoadingCall.html("loading-container")}</>;
  } else if (isNotLoggedIn) {
    return (
      <div id="container">
        <TopBar loginData={loginData} storeLoginData={storeLoginData} />
        <div id="box-container" style={{ width: "100%" }}>
          {/* <div style={{ padding: "24px 16px", textAlign: "center" }}>
            <div style={{ color: "#444", fontSize: "14px" }}>
              Please sign in with Google to access this page.
            </div>
          </div> */}
        </div>
      </div>
    );
  } else if (loginData.err === 1) {
    return <NotFound />;
  }
  return (
    <div id="container">
      <TopBar loginData={loginData} storeLoginData={storeLoginData} />
      <div id="box-container" style={{ width: "100%" }}>
        <Router>
          <Switch>
            <Route
              path="/tourplan/copy_rates.php"
              exact
              component={CopyRates}
            />
            <Route
              path="/tourplan/export_sql.php"
              exact
              component={ExportSql}
            />
            {<Route path="/tourplan/" component={NotFound} />}
          </Switch>
        </Router>
        {LoadingCall.html("loading-container")}
      </div>
    </div>
  );
}
